// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f6262c23","453":"95d7ada0"}[chunkId] + ".chunk.js";
};